/* =============================================================================
 * ASSETS DE /cancun — TODO sale de `@/assets/manifest` (dominio FORGE-BRAVO)
 * -----------------------------------------------------------------------------
 * La versión anterior de este fichero declaraba que de Cancún no había NADA y
 * servía la costa del hub (`hub/card-cancun`) recortada de dos maneras, con la
 * cortina resuelta en CSS y los medallones del programa sin fotografía. Era
 * cierto en su momento y ya no lo es: `forge/bravo` entrega las once piezas.
 *
 * Aquí no hay rutas: sólo CLAVES del manifiesto. Quien las pinta es
 * `ResponsiveImage` (substrato de FORGE-ALPHA), que además pone el `alt`.
 * El emblema de marca no está: `Brandmark` ya lo trae de serie (ADR-002).
 * ========================================================================== */

import type { AssetKey } from '@/assets/manifest';

export const cancunMedia = {
  /** Escena costera a nivel de ojo: mar turquesa, vegetación y ruina discreta. */
  heroScene: 'cancun/hero',
  /** Cortina blanca con anilla dorada, alfa real. Enmarca el hero por la izquierda. */
  heroCurtain: 'cancun/cortina-recorte',
  /** Hoja de palmera a contraluz, alfa real. Asoma por arriba-izquierda. */
  palmLeaf: 'cancun/palmera-recorte',
  /** Retrato real recortado con alfa — hero. */
  heroPortrait: 'azrahel/recorte',
  /** Acantilado con ruina maya: flanco derecho del programa. */
  ruins: 'cancun/ruinas-lateral',
  /** Panorámica de playa 2:1 — fondo del strip premium. */
  beachStrip: 'cancun/franja-mar',
  /** Retrato real (camisa blanca, brazos cruzados) — bloque de cierre. */
  closingPortrait: 'azrahel/retrato',
  /** Tabla de tarifas «todo incluido» del Hotel Palmaïa, JPG del cliente (14-sep-2026). */
  hotelRates: 'cancun/tarifas-palmaia',
} as const satisfies Record<string, AssetKey>;

/**
 * Las seis miniaturas del rail del programa, por id de bloque de la agenda real
 * (`src/features/events`). El reparto es 3 + 3 y el ritual del fuego es del DÍA
 * 2 — ver la desviación declarada en `docs/VISUAL_DEVIATIONS.md`.
 *
 * El tipo admite `undefined` a propósito: si mañana cambiara la selección de
 * `isHighlight`, un hito nuevo entra con su medallón de ornamento en vez de
 * reventar la página.
 */
export const cancunThumbs: Record<string, AssetKey | undefined> = {
  'cu-d2-amanecer': 'cancun/thumb-amanecer',
  'cu-d2-cenote': 'cancun/thumb-cenote',
  'cu-d2-camara': 'cancun/thumb-camara-atardecer',
  'cu-d3-bio': 'cancun/thumb-guerrero',
  'cu-d3-fogata': 'cancun/thumb-ritual-fuego',
  'cu-d3-gala': 'cancun/thumb-cena-gala',
};

/**
 * NO HAY BANDERA AQUÍ, Y ES DELIBERADO.
 *
 * Esta página servía `@/assets/icons/flags/mx.svg`: verde `#006847`, blanco y
 * rojo `#CE1126` en tres franjas verticales, sin escudo. Una bandera de México
 * sin escudo no es una bandera de México simplificada — es la bandera de
 * Italia, que es exactamente ese tricolor y nada más. Se servía en la página
 * del evento mexicano con `alt="Bandera de México"`, así que también mentía al
 * lector de pantalla.
 *
 * El escudo no se puede aproximar (doctrina del repo, §Lecciones), de modo que
 * el hero pinta `event.flag` — el mismo emoji 🇲🇽 que el hub, que trae la
 * bandera real con su águila. Avisado a FORGE-BRAVO, dueño del asset.
 * (ORACLE + CENTINEL, 25-jul-2026.)
 */
